<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <div
            v-if="isNucleotide"
            slot="label"
        >
            <span>{{ $t(fieldConfig.label) }}</span>
            <ElPopover
                placement="right"
                trigger="hover"
                :visible-arrow="false"
                popper-class="bio-search-setting__popover"
            >
                <div class="popover-explain">
                    {{ $t('Search.explanation.scoreMatrixDefaultTip') }}
                </div>
                <PtIcon
                    slot="reference"
                    icon="SolidInfo"
                />
            </ElPopover>
        </div>
        <ElSelect
            v-model="fieldValue"
            class="search-preference__select"
            :placeholder="$t(fieldConfig.label)"
            size="small"
            @change="syncChange"
        >
            <ElOption
                v-for="option in matrixOptions"
                :key="option"
                :label="option"
                :value="option"
            />
        </ElSelect>
    </FieldItem>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import { ScoreMatrixOptions, NucleotideScoreMatrixOptions, ABST_NUC } from '../constants';

export default {
    components: {
        FieldItem,
        ElSelect: Select,
        ElOption: Option,
        ElPopover: Popover,
        PtIcon,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'score_matrix',
        },
    },
    computed: {
        sequenceType() {
            return this.store.settingValues.sequenceType;
        },
        isNucleotide() {
            return this.sequenceType === ABST_NUC;
        },
        matrixOptions() {
            // 如果是核苷酸序列类型，返回核苷酸打分矩阵选项
            if (this.isNucleotide) {
                return NucleotideScoreMatrixOptions;
            }
            // 否则返回蛋白质打分矩阵选项
            return ScoreMatrixOptions;
        },
    },
    watch: {
        sequenceType: {
            handler(newType, oldType) {
                // 当序列类型改变时，检查当前值是否在新的选项列表中
                this.validateAndSetDefault();
            },
            immediate: true,
        },
        matrixOptions: {
            handler() {
                // 当选项列表改变时，检查当前值是否仍然有效
                this.validateAndSetDefault();
            },
        },
        'store.isInitValues': {
            handler(isInit) {
                // 当初始化完成后，验证并设置默认值
                if (!isInit) {
                    this.$nextTick(() => {
                        this.validateAndSetDefault();
                    });
                }
            },
        },
    },
    mounted() {
        // 组件挂载时确保有正确的默认值
        this.$nextTick(() => {
            this.validateAndSetDefault();
        });
    },
    methods: {
        validateAndSetDefault() {
            const currentValue = this.fieldValue;
            const isValidValue = this.matrixOptions.includes(currentValue);

            // 如果当前值不在选项列表中，或者没有值，设置默认值
            if (!isValidValue || !currentValue) {
                const defaultValue = this.isNucleotide ? 'DEFAULT' : 'BLOSUM62';
                if (this.fieldValue !== defaultValue) {
                    this.fieldValue = defaultValue;
                    this.syncChange();
                }
            }
        },
    },
};
</script>
